// Types
export interface ColorOption {
  value: string;
  label: string;
  color: string;
}

export type ColorType = 'boundaryColor' | 'polygonColor';
export type DropdownType = 'boundary' | 'polygon';

// Color options configuration
export const COLOR_OPTIONS: ColorOption[] = [
  { value: '', label: 'None', color: 'transparent' },
  { value: 'primary', label: 'Primary', color: '#007bff' },
  { value: 'warning', label: 'Warning', color: '#ffc107' },
  { value: 'danger', label: 'Danger', color: '#dc3545' },
];

// Helper function to get selected color option
export const getSelectedColor = (value: string): ColorOption => {
  return (
    COLOR_OPTIONS.find(option => option.value === value) || COLOR_OPTIONS[0]
  );
};

// Handle color selection
export const handleColorSelect =
  (
    onNoteChange: (type: string, value: string) => void,
    setBoundaryOpen: (value: boolean) => void,
    setPolygonOpen: (value: boolean) => void,
  ) =>
  (type: ColorType, value: string): void => {
    onNoteChange(type, value);
    if (type === 'boundaryColor') {
      setBoundaryOpen(false);
    } else {
      setPolygonOpen(false);
    }
  };

// Handle dropdown toggle
export const handleDropdownToggle =
  (
    setBoundaryOpen: (fn: (prev: boolean) => boolean) => void,
    setPolygonOpen: (fn: (prev: boolean) => boolean) => void,
  ) =>
  (type: DropdownType): void => {
    if (type === 'boundary') {
      setBoundaryOpen(prev => !prev);
      setPolygonOpen(() => false);
    } else {
      setPolygonOpen(prev => !prev);
      setBoundaryOpen(() => false);
    }
  };
